<template>
  <div>
    <div class="tip" :style="{ display: showTip ? 'flex' : 'none' }"></div>
    <div class="tip-cover" :style="{display:showTip?'flex':'none'}">
      <img :src="tipType[type]">
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tip",
  data() {
    return {
      tipType: {
        error: require("../assets/img/cuowu2x.png"),
        success: require("../assets/img/tijiao2x.png"),
        warning: require("../assets/img/jinggao2x.png"),
      },
      showTip: false
    };
  },
  props: {
    show: {
      type: String,
      default: "0"
    },
    message: {
      Type: String,
      required: true
    },
    type: {
      Type: String,
      default: "success"
    }
  },
  watch: {
    show(val, old) {
      if (val[0] == "1") {
        this.showTip = true;
        setTimeout(_ => {
          this.showTip = false;
        }, 1500);
      }
    }
  }
};

</script>

<style scoped>
.tip {
  opacity: 0.35;
  background: #000000;
}

.tip, .tip-cover {
  z-index: 2;
  position: absolute;
  margin: auto auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 10px;
  width: 140px;
  height: 110px;
  color: white;
}

.tip-cover {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tip-cover img {
  z-index: 3;
  width: 35px;
}

.tip-cover p {
  margin: 0;
  margin-top: 10px;
  color: #fff;
  font-size: 15px;
  text-align: center;
}
</style>
